module.exports = __webpack_public_path__ + "static/joseph-cervantes-76527359f3b2e9ef6858166222261cb9.jpg";